// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ChoiceContext, GetChoiceContextRequest } from '@digitalasset/allocation-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { ContractId } from '@daml/types';
import { useAllocationApiClient } from '../../../contexts/AllocationApiContext';

export const useAllocationTransferContext: () => UseMutationResult<
  ChoiceContext,
  string,
  {
    registrar: string;
    allocationCid: ContractId<Allocation>;
  }
> = () => {
  const allocationApi = useAllocationApiClient();
  const getChoiceContextRequest: GetChoiceContextRequest = { meta: {} };

  return useMutation({
    mutationKey: ['allocationTransferContext', allocationApi],
    mutationFn: async ({ registrar, allocationCid }) => {
      return allocationApi.getAllocationTransferContext(
        allocationCid,
        registrar,
        getChoiceContextRequest,
      );
    },
  });
};
